import { useIntl } from 'react-intl';
import { useNavigate, useOutletContext } from 'react-router-dom';
import AccionaBigButton from '../../../../../components/AccionaBigButton';

const Options = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useOutletContext();
  return (
    <div className="row">
      <div className="col-sm-12 col-md-6">
        <AccionaBigButton
          icon="tbm"
          msg={intl.formatMessage({ id: 'routes.options.projectConfig' })}
          onClick={() =>
            navigate(`/app/project/${project.id_project}/options/edit`)
          }
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <AccionaBigButton
          icon="admin"
          msg={intl.formatMessage({ id: 'routes.options.users' })}
          onClick={() =>
            navigate(
              `/app/project/${project.id_project}/options/usersManagment`,
            )
          }
        />
      </div>
    </div>
  );
};

export default Options;
